<div class="lightContent">
  <div class="headingPage">
    <ng-container *ngIf="relatedStoryType === 'alsoread'">
      <h2 class="">Select Also Read Stories</h2>  
    </ng-container>
    <ng-container *ngIf="relatedStoryType !== 'alsoread'">
      <h2 class="">Select Related Stories</h2>
    </ng-container>    
  </div>
    <div class="listing"
    [pageId]="'all_related_stories'"
    [allApi]="'all_story'"
    [searchApi]="'all_story'"
    [suggestionApi]="'story_suggestions'"
    [metaApi]="'dashboard_meta'"
    [RelatedStorySearch]="true"
    [storyId]= "story_Id"
    [showPagination]="false"
    [multipleStories]="chooseMultiple"
    [storyIdArray]="storyIdList"
    (sendIdToParentfn)="storySelected($event)"
    (sendRelatedStoryGalleryType)="getRelatedStoryGalleryTypeData($event)"
    [relatedStoryType]="relatedStoryType"

    search_label="Search Stories..."></div>


    <div class="right" *ngIf="chooseMultiple">
      <button *ngIf="enableRelatedStoryPreview && showNextButton" type="button" class="green shiftL" (click)="openEditRelatedStoryPopup()" [disabled]="storyIdList.length < 1">Next</button>
      <!-- <button type="button"  class="shiftL">Skip</button> -->
      <button type="button" name="discard" class="discard gray" (click)="closePopup()">Close</button>
      <button type="button" name="save" id="buttonSubmitForRelatedStory" class="save blue" (click)="storiesSelected()" [disabled]="storyIdList.length < 1">Choose {{storyIdList.length}} Stories</button>
      <!-- <button type="button" name="save" id="buttonSubmitForRelatedStory" class="save blue" (click)="openEditRelatedStoryPopup()" [disabled]="storyIdList.length < 1">Next</button> -->
    </div>
</div>

<!--
    <div class="lightContent">
            <div class="headingPage">
              <h2 class="">Select Related Stories</h2>
            </div>
            <div class="searchBlock">
              <div class="searchSection spImg">
                <div class="searchtxt">
                  <input type="text" class="textBox" placeholder="Search Stories &amp; Cards">
                </div>
              </div>
              <div class="filterSection spImg">
                <div class="fliterBlock spImg">
                  <ul class="filterOption">
                    <li class="togfilt checkactive"><span class="spImg">Created By</span>
                      <div class="filterdrop">
                        <input type="text" class="textBox" id="a">
                        <ul>
                          <li>
                            <label class="checkblock">Movie Rating
                              <input type="checkbox">
                              <span class="checkmark"></span> </label>
                          </li>
                          <li>
                            <label class="checkblock">Scorecard
                              <input type="checkbox">
                              <span class="checkmark"></span> </label>
                          </li>
                          <li>
                            <label class="checkblock">Sensex
                              <input type="checkbox">
                              <span class="checkmark"></span> </label>
                          </li>
                          <li>
                            <label class="checkblock">Horoscope
                              <input type="checkbox">
                              <span class="checkmark"></span> </label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li><span class="spImg">Section</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="headingsList">
              <ul>
                <li class="headline">Headline </li>
                <li class="format">Format</li>
                <li class="domain">Domain</li>
                <li class="section">Section</li>
                <li class="byline">Byline</li>
                <li class="publishedat">Published At</li>
                <li class="actions">Actions</li>
              </ul>
            </div>
            <div class="contentList" style="height: 505px;">
              <ul class="selected">
                <li class="headline spImg"> <small>Dinesh Chandimal denies ball tampering with sweet, rescues Sri Lanka</small> </li>
                <li class="format">Story</li>
                <li class="domain">Hindustan TImes</li>
                <li class="section">Cricket</li>
                <li class="byline">Nancy Moss</li>
                <li class="publishedat">Mar 27, 18:30</li>
                <li class="actions"><span class="edit spImg_story"></span></li>
              </ul>
            </div>
          </div>
   -->
